<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-app id="inspire">
      <v-layout
        wrap
        justify-center
        class="login_page"
        style="background-color:white"
        :style="{
          'background-image': 'url(' + mediaURL + backgroundImage + ')',
        }"
      >
        <v-flex xs12 sm6 md4 lg3 px-2 align-self-center>
          <v-layout wrap justify-center>
            <v-flex xs112 xl10>
              <v-snackbar
                v-model="showSnackBar"
                color="#3EA56E"
                right
                :timeout="timeout"
              >
                <v-layout wrap justify-center>
                  <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
                  <v-flex text-right>
                    <v-btn
                      small
                      :ripple="false"
                      text
                      @click="showSnackBar = false"
                    >
                      <v-icon style="color: white">mdi-close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-snackbar>
              <v-card tile elevation="2">
                <v-layout wrap justify-center>
                  <v-flex xs12>
                    <v-img
                          src="./../../assets/Images/logBG.png"
                          contain
                          class="align-left"
                        >
                        <v-layout wrap pa-8>
                 <v-flex xs12 text-left>
                 <span class="cwhite medium ibmbold">Let’s make the <br>  planet Clean</span> <br>
                 <span style="color:#939393" class="smallm ibmbold">Use Promo Code</span> <br>
                  <span class="cwhite" style="border: 1px dashed grey ;font-size:12px;padding:2px" >&nbsp;SAVE10 </span>
                 </v-flex>
               </v-layout>
                        </v-img>
                  </v-flex>
                  <v-flex px-8 py-6>
                    <v-layout wrap justify-center>
                      <!-- <v-flex xs12>
                        <span
                          style="
                            font-family: poppinsmedium;
                            font-size: 15px;
                            color: #b8b8b8;
                          "
                          >Welcome to
                        </span>
                         
                      </v-flex> -->
                      <v-flex xs12>
                        <!-- <v-layout wrap justify-start>
                          <v-flex xs7 px-2>
                            <span
                              class="ibmbold"
                            >
                              Log in <span class="ibmregular">or</span> Sign up
                            </span>
                          </v-flex>
                        </v-layout> -->
                        <!-- <v-layout wrap justify-center>
                          <v-flex xs5 lg6 xl2 px-2 pt-2>
                            <v-progress-linear
                              height="2"
                              value="100"
                              color="#3EA56E"
                            ></v-progress-linear>
                          </v-flex>
                        </v-layout> -->
                      </v-flex>
                      <v-flex pt-2 xs12 text-left>
                        <v-layout wrap justify-center>
                          <v-flex xs12 pb-8>
                            <span
                              class="ibmbold"
                            >
                              Log in <span class="ibmregular">or</span> Sign up
                            </span>
                          </v-flex>
                          <!-- <v-flex xs12 pb-2>
                            <span
                              style="
                                font-family: ;
                                font-size: 12px;
                                color: #ababab;
                              "
                            >
                              Mobile Number
                            </span>
                          </v-flex> -->
                          <v-flex xs12>
                            <v-form @submit.prevent="validateInput">
                              <v-text-field
                                ref="phone"
                                color="#3EA56E"
                                placeholder="Mobile number"
                                outlined
                                dense
                                type="number"
                                v-model="phone"
                                :rules="[rules.required, rules.min]"
                              >
                                <template v-slot:prepend-inner>
                                  <v-layout justify-center>
                                    <v-flex pt-0 class="align-self-center">
                                      <span
                                        style="
                                          font-family: poppinsregular;
                                          font-size: 15px;
                                          color: #000;
                                        "
                                        >+91</span
                                      >
                                    </v-flex>
                                    <v-flex pt-1 pl-2 xs1>
                                      <v-divider vertical></v-divider>
                                    </v-flex>
                                  </v-layout>
                                </template>
                              </v-text-field>
                            </v-form>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex>
                        <span class="ibmregular smallm" style="color:#747474;">
                          By continuing, I agree to the <span class="ibmbold cgreen"  @click="$router.push('/termsandCondition')" style="cursor:pointer"> Terms of Use </span><span class="ibmbold cgreen"  style="color:#747474 !important">&</span><span class="ibmbold cgreen"  @click="$router.push('/privacyPolicy')" style="cursor:pointer"> Privacy Policy </span>
                        </span>
                      </v-flex>
                      <v-flex xs12 py-6>
                        <v-btn
                          block
                          tile
                          color="#3EA56E"
                          dark
                          :ripple="false"
                          depressed
                          @click="validateInput"
                        >
                          <span
                            style="
                              font-family: poppinssemibold;
                              font-size: 12px;
                              text-transform: none;
                            "
                            >Continue
                          </span>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-app>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["pageData", "backgroundImage"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      formHasErrors: false,
      timeout: 5000,
      msg: null,
      phone: "",
      rules: {
        required: (value) => !!value || "Required",
        min: (value) => value.length == 10 || "Invalid Phone",
      },
    };
  },
  beforeMount() {
    if (this.pageData.phone) {
      this.phone = this.pageData.phone;
    }
  },
  computed: {
    form() {
      return {
        phone: this.phone,
      };
    },
  },
  mounted() {
    this.setMetaTags();
  },
  methods: {
    setMetaTags() {
      document.title = "Login or Sign up | KL-06 FARM";
      let metaDescription = document.querySelector('meta[name="description"]');
      const description = "Login or Sign up to KL-06 FARM to manage your orders, saved addresses, and profile.";
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      } else {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        metaDescription.content = description;
        document.head.appendChild(metaDescription);
      }
    },
    validateInput() {
      this.formHasErrors = false;

      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) {
          this.formHasErrors = true;
          this.msg = "Please Provide " + f;
          this.showSnackBar = true;
          return;
        }
        if (!this.$refs[f].validate(true)) {
          this.msg = "Please Provide Valid " + f;
          this.showSnackBar = true;
          this.formHasErrors = true;
          return;
        }
      });
      if (this.formHasErrors == false) this.login();
    },
    login() {
      var userData = {};
      userData["phone"] = this.phone;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/getsms",
        data: userData,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            if (response.data.type != "Admin") {
              if (!response.data.isnew) {
                this.$emit("stepper", {
                  phone: this.phone,
                  response: response.data,
                  winStep: 1,
                });
              } else {
                this.$emit("stepper", {
                  phone: this.phone,
                  response: response.data,
                  winStep: 2,
                });
              }
            } else {
              this.msg = "You are not authorised to login here";
              this.showSnackBar = true;
            }
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>